import React from 'react'
import { ReactComponent as ArrowSVG } from 'svg/fi_chevrons-right.svg'

export const FeatureDescription = (props: any) => {
  const { description1, description1_1, description2 } = props
  return (
    <div className="p-5 flex items-center justify-center flex-col gap-5">
      <ArrowSVG />
      <div className="text-[20px] text-center text-[#8F929B]">
        <p>
          ↑위 영역에서{' '}
          <span className="text-main font-bold">{description1}</span>
          {description1_1 ?? '를 먼저 넣어주시면'}
        </p>
        <p>
          {' '}
          ↓아래 <span className="text-main font-bold">{description2}</span>들이
          활성화 됩니다.
        </p>
      </div>
      <ArrowSVG />
    </div>
  )
}
